
const host: string = window.location.host;

let IS_AGENT_MODE: boolean = false;
let IS_NO_CODE: boolean = false;

// Defaults (preview.cometchat.com/)
IS_AGENT_MODE = false;
IS_NO_CODE = false;

// Check route for AI Agents mode
if (host === "ai-agents.cometchat.com" || host === "localhost:3000") {
  IS_AGENT_MODE = true;
  IS_NO_CODE = true; // Change if no-code applies
}


const COMETCHAT_CONSTANTS = {
  APP_ID: '267879a77f4b29cd',
  REGION: 'in',
  LOGGED_IN_USER_ID: '',
  AUTH_TOKEN_URL: 'https://demo-service.cc-cluster-2.io/auth-token',
};
export { IS_AGENT_MODE, IS_NO_CODE,  COMETCHAT_CONSTANTS };
